import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import {
  BrowserRouter as Router
} from 'react-router-dom';
import './App.css';
import Routes from './Routes';
import './styles/sb-admin-2.css';


function App() {
  return (
    <Router>
      <div>
        <Routes />
      </div>
    </Router>
  );
}

export default App;
